import { Line as o } from "./components.js";
import { LineSystem as e } from "./systems.js";
const r = {
  systems: [e],
  components: {
    Line: o
  },
  config: {
    defaults: {
      line: {
        offsetX: 1,
        offsetY: 0,
        offsetZ: 0,
        color: 16777215,
        thickness: 2,
        opacity: 1,
        visible: 1,
        arrowStart: 0,
        arrowEnd: 0,
        arrowSize: 0.2
      }
    }
  }
};
export {
  r as LinePlugin
};
//# sourceMappingURL=plugin.js.map
